import React, { useEffect, useState } from 'react';
import './ActiveFilters.scss';
import useMediaQuery from '../../../../../utils/useMediaQuery';

const ActiveFilters = props => {
  const {
    FilterDataObj,
    filterData,
    modifySelectedFilterList,
    categoryData,
    showSortDropdown,
    toggleSortDropdown,
    sortWrapperRef,
    isSearch,
    location,
    totalProducts,
  } = props;

  const [cachedCategoryName, setCachedCategoryName] = useState('');
  const [cachedNumOfProducts, setCachedNumOfProducts] = useState(null);
  const isDesktopSize = useMediaQuery('(min-width: 768px)');

  useEffect(() => {
    if (categoryData?.result?.category_name) {
      setCachedCategoryName(categoryData.result.category_name);
    }
    if (typeof totalProducts === 'number') {
      setCachedNumOfProducts(totalProducts);
    }
  }, [categoryData]);

  const cleanedFilterDataObj = Object.entries(FilterDataObj).reduce(
    (acc, [filterName, selectedOptions]) => {
      if (selectedOptions.length) {
        acc[filterName] = selectedOptions;
      } else {
        delete FilterDataObj[filterName];
      }

      return acc;
    },
    {}
  );

  const filterDataAll = filterData && filterData.result && filterData.result.filters;
  const sortButtonRef = sortWrapperRef || React.createRef();
  const isSearchKeyword = location?.search?.replace(/^\?q=/, '') || '';

  return (
    <React.Fragment>
      <div className={`active-filter ${!isSearch && !isDesktopSize ? 'search-hidden' : ''}`}>
        <div className="active-filter__left">
          <div className="active-filter__breadcrumb">
            <span className="active-filter__category">{cachedCategoryName}</span>
            {cachedNumOfProducts !== null && (
              <span className="active-filter__count">
                · {cachedNumOfProducts} Items ·{' '}
                {isSearch && (
                  <>
                    results for
                    <span className="active-filter__count--keyword">"{isSearchKeyword}"</span>
                  </>
                )}
              </span>
            )}
          </div>

          <div className="active-filter__tags">
            {filterDataAll &&
              Object.entries(cleanedFilterDataObj).map(([filterName, selectedOptions]) =>
                selectedOptions.map(({ childid, childname }) => (
                  <div key={childid} className="active-filter__tag">
                    {childname}
                    <span
                      className="active-filter__tag-close"
                      onClick={() =>
                        modifySelectedFilterList(childname, childid, { id: filterName })
                      }
                    />
                  </div>
                ))
              )}
          </div>
        </div>
        <div
          ref={sortButtonRef}
          className={`active-filter__right ${isSearch ? 'search-hidden' : ''}`}
        >
          <button
            className={`active-filter__sort ${showSortDropdown ? 'active-filter__sort--open' : ''}`}
            onClick={toggleSortDropdown}
          >
            Sort by
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ActiveFilters;
